import { apiCall } from './common.js';

export const apiGetReleasesList = (params) => apiCall({endpoint: 'releases', method: 'GET', params: params});
export const getRelease = (uuid) => apiCall({endpoint: `release/${uuid}`, method: 'GET'});
export const createRelease = (data) => apiCall({endpoint: 'release', method: 'POST', body: data});
export const createReleasev1 = (data) => apiCall({endpoint: 'v1/release', method: 'POST', body: data});
export const deleteRelease = (uuid) => apiCall({endpoint: `release/${uuid}`, method: 'DELETE'});
export const getBranchReleases = (uuid) => apiCall({endpoint: `v1/releases?branch=${uuid}`, method: 'GET'});
export const triggerPostReleaseVersionBump = (version, data) => apiCall({endpoint: `v1/release/${version}/post-release-version-bump`, method: 'POST', body: data});
export const validateBinaries = (version) => apiCall({endpoint: `v1/release/${version}/validate-binaries`, method: 'POST', body: {}});

export const apiTriggerStep = (uuid, data) => apiCall({endpoint: `step/${uuid}/trigger`, body: data, method: 'POST'});

// Update releases
export const setReleaseTag = (version, data) => apiCall({endpoint: `release/${version}`, body: data, method: 'PATCH'});
export const apiGetReleaseNotes = (version) => apiCall({ endpoint: `v1/release/${version}/release-notes`, method: 'GET' });
